import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const CompanyInfoModal = ({ isOpen, toggle, data }) => {
  if (!data) return null;

  const { overview, officers, psc, charges, filing_history } = data;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Company Details: {overview?.company_name}</ModalHeader>
      <ModalBody>
        <div>
          <h5>📝 Company Overview</h5>
          <p><strong>Company Number:</strong> {overview?.company_number}</p>
          <p><strong>Status:</strong> {overview?.company_status}</p>
          <p><strong>Incorporation Date:</strong> {overview?.date_of_creation}</p>
          <p><strong>Address:</strong> {overview?.registered_office_address?.address_line_1}, {overview?.registered_office_address?.postal_code}</p>

          <hr />

          <h5>👤 Directors</h5>
          <ul>
            {officers?.items?.map((officer, i) => (
              <li key={i}>
                {officer.name} ({officer.officer_role}) — Appointed on: {officer.appointed_on}
              </li>
            ))}
          </ul>

          <h5>👥 Persons with Significant Control</h5>
          <ul>
            {psc?.items?.map((person, i) => (
              <li key={i}>
                {person.name || person?.name_elements?.forename + ' ' + person?.name_elements?.surname}
              </li>
            ))}
          </ul>

          <h5>📄 Filing History (Top 5)</h5>
          <ul>
            {filing_history?.items?.slice(0, 5).map((filing, i) => (
              <li key={i}>{filing.description} — {filing.date}</li>
            ))}
          </ul>

          <h5>💰 Charges</h5>
          <p>{charges?.items?.length || 0} charges found.</p>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CompanyInfoModal;
